export const CHANGE_BL_STATUS_FILTER = "CHANGE_BL_STATUS_FILTER";
export const SET_BL_STATUS_LOADING = "SET_BL_STATUS_LOADING";
export const GET_STATISTIC_SUCCESS = "GET_STATISTIC_SUCCESS";
export const GET_SYSTEM_STATUS_SUCCESS = "GET_SYSTEM_STATUS_SUCCESS";
